/******************************************************************
***********   Event handler definitions ***************************
******************************************************************/

$('body').on('click', '.jmt-fasciawear-benefit', function() {
  var selector = $(event.target).parents('div.jmt-fasciawear-benefit');
  var target = '#fasciawear-'+ selector.attr('data-target');
  if(!$(selector).find('p.jmt-benefit-detail-selector').hasClass('jmt-benefit-detail-selector-active')) {
    $('.jmt-fasciawear-benefit-detail-active').removeClass('jmt-fasciawear-benefit-detail-active');
    $('.jmt-benefit-detail-selector-active').removeClass('jmt-benefit-detail-selector-active');
    $(target).addClass('jmt-fasciawear-benefit-detail-active');
    $(selector).find('p.jmt-benefit-detail-selector').addClass('jmt-benefit-detail-selector-active');
  }

});

$(document).on("click", ".jmt_custom_size_guide", function (e) {
               var anchor = $(this);
               jQuery(".size_guide_tab > a,.size_guide_tab .tab-heading").trigger("click");
               setTimeout(function () {
                  window.scrollTo(0, 0);
               }, 1);
               setTimeout(function () {
                  $('html, body').stop().animate({
                     scrollTop: $(anchor.attr('href')).offset().top - 100
                  }, 400);
               }, 10);
               e.preventDefault();
});

// Other event handlers for window
// User scroll
$( window ).on('scroll', function(){
	var loc = $( window ).scrollTop();
	var height = $( document ).height();
	var wHeight = $( window ).height();
	if( loc > height/2) {
		if(wMid == false) {
			wMid = true;
			ga('send', {
  				hitType: 'event',
  				eventCategory: 'ScrollOnPage',
  				eventAction: 'userscroll',
  				eventLabel: 'Scrolled Mid Page',
  				eventValue: 0
			});
		}
	}
	if ( loc + wHeight == height) {
		if(wEnd == false) {
			wEnd = true;
			ga('send', {
  				hitType: 'event',
  				eventCategory: 'ScrollOnPage',
  				eventAction: 'userscroll',
  				eventLabel: 'Scrolled Page Bottom',
  				eventValue: 0
			});
		}
	//console.log('scrolled bottom');
	}
});

$('body').on('click','.toggle-visibility', function() {
  if($(this).hasClass('active')) {
    $(this).find('.ui-interaction-element').removeClass('opened');
    $(this).removeClass('active');
    $(this).find('div.product_info_details').css('display','none');
  } else {
    $(this).find('.ui-interaction-element').addClass('opened');
    $(this).addClass('active');
    $(this).find('div.product_info_details').css('display','block');
  }
});

$('body').on('click','.btn-size-guide-selector', function() {
  console.log("fire away")
  if(!$(this).hasClass('active')) {
    if($(this).hasClass('mas-metric')) {
      $('.mas-imperial').removeClass('active');
      $('.mas-metric').addClass('active');
      $('tbody.metric').removeClass('mas-hidden');
      $('tbody.imperial').addClass('mas-hidden');
    } else {
      $('.mas-metric').removeClass('active');
      $('.mas-imperial').addClass('active');
      $('tbody.imperial').removeClass('mas-hidden');
      $('tbody.metric').addClass('mas-hidden');
    }
  }
});
$("body").on('click','.size-selection-guide', function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#size-guide").offset().top
    }, 2000);

});